<div class="brand flex-column-auto" [ngClass]="brandClasses">
  <a href="javascript:;" routerLink="/" class="brand-logo">
    <img alt="logo" width="65%" [attr.src]="headerLogo" />
  </a>
<!--  <button class="brand-toggle btn btn-sm px-0" id="left_menu_aside_toggle" (click)="toggleAsideClick()">-->
<!--    <mat-icon svgIcon="can-menu-toggle" class="svg-icon svg-icon svg-icon-xl"></mat-icon>-->
<!--  </button>-->
</div>
